module.exports = __webpack_public_path__ + "static/media/other-icon.e2613a9a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/other-icon.svg
// module id = 45
// module chunks = 0